import { Confirm } from '@services/MarppleShop/renderApp/components/cells/Confirm/Confirm.ts';
import { preventEscape } from '@services/MarppleShop/shared/util/preventEscape.ts';
import { MShopUtilF } from '@modules/MShop/Util/F/Function/module/MShopUtilF';
import { pushLoginStack } from '@modules/Creator/Login/F/fs';
import { updateLikeApiHelper } from '@modules/MShop/App/Product/Item/F/Function/updateLikeApiHelper';
import { createPopToastMsgForMarppleShop } from '@modules/MShop/Util/F/Function/createPopToastMsgForMarppleShop';

const popToastMsg = createPopToastMsgForMarppleShop();

/**
 * @see https://github.com/marpple/marpple-web/blob/c69213b737c26d28b5417bc5767aaf4a2b953760/services/MarppleShop/renderApp/components/cells/ProductCard/ProductCardView.ts#L301-L329
 */
export const requestUpdateProductIsLikedOrLogin = async (
  isLiked: boolean,
  user_id: number | null | undefined,
  storesProductId: number,
) => {
  if (!user_id || window.box.sel('is_user->type') == 'TEMP') {
    const confirmed = (await Confirm.open({
      title: ET('mps2::login::need_login::title'),
      message: preventEscape(ET('mps2::login::need_login::message')),
      confirmText: ET('mps2::login::login'),
      cancelText: ET('mps2::signup::close'),
    })) as boolean;

    if (confirmed) {
      if (MShopUtilF.isApp()) {
        pushLoginStack();
      } else {
        location.href = `/${T.lang}/@/login?url=${location.pathname + location.search}`;
      }
    }

    return Promise.reject();
  } else {
    const alreadyLike = !isLiked;

    /**
     * @see updateLikeMarppleShop
     */
    const ok = await updateLikeApiHelper.post(alreadyLike, storesProductId);
    if (!ok) {
      return Promise.reject();
    }

    popToastMsg(
      alreadyLike ? T('mshop::좋아요 목록에서 삭제되었습니다.') : T('mshop::좋아요 목록에 추가되었습니다.'),
      alreadyLike ? 'error' : 'like',
      { has_bottom_margin: false },
    );
  }
};
